import {Route, Switch} from 'react-router-dom'
import NotFound from '@super-template/core/src/NotFound'
import * as welcome from './welcome'
import * as calendar from './calendar'
import * as info from './info'
import * as application from './application'
import * as cookies from './cookies'
import * as accessibility from './accessibilityStatement'
import Suspense from 'suspense-overlay';
import IsValidOrganization from '@super-template/core/src/IsValidOrganization'
import {UseOptions} from "./utils";
import CircularProgress from '@material-ui/core/CircularProgress';
import Home from "./Home";

export const organizationPath = '/:organization';

export default function Routes() {
  return (
    <Switch>
      <Route path={'/admin'} exact>
        <Home/>
      </Route>
      <Route path={'/'} exact>
        <NotFound/>
      </Route>
      <Route path={organizationPath}>
        <IsValidOrganization fallback={<NotFound/>}>
          <Suspense fallback={<CircularProgress/>}>
            <UseOptions>
              <Switch>
                <Route {...cookies}/>
                <Route {...accessibility} />
                <Route {...welcome} />
                <Route {...calendar} />
                <Route {...info} />
                <Route {...application} />
                <Route component={NotFound}/>
              </Switch>
            </UseOptions>
          </Suspense>
        </IsValidOrganization>
      </Route>
      <Route component={NotFound}/>
    </Switch>
  )
}
